export class Sponsee {

  constructor(public sponsorId: number,
    public expirationMonth: number,
    public expirationYear: number,
    public studentId: number,
    public name: string) { }
}

